import { useMemo } from 'react';
import { ITest } from '../../Intarfaces/ITest';
import classes from './Test.module.css'

const Question = ({item={} as ITest, answer=null as null|number, setValue = (id: number, value: number)=>{}}) => {

    const question = useMemo(()=>{return(
        <div key={"q"+item.id} id={"q"+item.id} className={classes.question}>
            <div className={classes.questionTitle}>
                {item.question}
            </div>
            <div className={classes.answers}>
            {
                item.answers.map((item2)=>{
                    return (
                        <div key={`${item.id}a${item2.id}`}  id={`${item.id}a${item2.id}`} className={classes.answer}>
                            <input type="radio" id={`${item.id}a${item2.id}`} name={`question${item.id}`} checked={answer===item2.id} onChange={(e)=>{setValue(item.id, Number(e.target.value))}} value={item2.id} />
                            <label htmlFor={`${item.id}a${item2.id}`}>{item2.text}</label>
                        </div>
                    )
                })
            }
            </div>
        </div>
    )},[answer, item])

    return ( 
        question
     );
}
 
export default Question;